import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Device } from './Device';
import { useAppSelector } from '../../../hooks/redux';

export const Devices: FC = () => {
  const { t } = useTranslation();
  const { userInfoState, isUserInfoDownloaded } = useAppSelector((state) => state.userInfoReducer);

  return (
    <div className="devices">
      <h3 className="bold">{t('accountSettings.devices')}</h3>
      {isUserInfoDownloaded && userInfoState?.Equipments ? (
        userInfoState.Equipments.map((device) => {
          return (
            <div key={device.title + device.serial}>
              <Device
                device={device.title}
                installed={device.set}
                serialNumber={device.serial}
                warranty={device.warranty}
                rent={device.rent}
              />
            </div>
          );
        })
      ) : (
        <p className="devices__no-devices">{t('accountSettings.noDevicesYet')}</p>
      )}
    </div>
  );
};
